import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { sumMinutesToHours } from 'modules/trainings/components/MyTrainings/RequestsComponent/RequestDetailComponent/useHoursAndMinutes'
import { WizardComponent } from 'modules/trainings/components/Shared/WizardComponent'
import { useCreateTrainingRequest } from 'modules/trainings/hooks/TrainingRequests/useCreateTrainingRequest'

import { closeModal } from './../actions'
import { useBenefitModals } from './../useBenefitModals'

export const TrainingRequestWizard = () => {
  const { dispatch } = useBenefitModals()
  const { create } = useCreateTrainingRequest()
  const {
    company: { id: companyId },
    access: { id: authorId },
  } = useCurrentSession()

  const {
    employee: { id: employeeId },
  } = useCurrentSession()

  return (
    <WizardComponent
      wizardConfig={{
        allowEmployeePayment: true,
        allowDraft: false,
      }}
      actions={{
        onClose: () => {
          dispatch(closeModal())
        },
        onSubmit: async (status, data) => {
          if (!data) return

          const result = await create({
            ...data,
            duration: sumMinutesToHours(data.duration, data.minutes),
            companyId: companyId,
            status: status ? status : data.status,
            authorId: authorId,
            // Only pass along employee cost and payment installations if the employee is paying for the training
            costToEmployee: data.paymentOption === 'employee' ? data.cost : undefined,
            paymentInstallments:
              data.paymentOption === 'employee' ? (data.paymentInstallments ?? 1) : undefined,
          })

          const handled = handleResult(result, () => {
            app.setFlash({
              type: 'wrong',
              message: i18n.t('trainings.training_requests.create.wrong'),
            })
          })

          if (handled.success) {
            app.setFlash({
              type: 'correct',
              message: i18n.t('trainings.training_requests.create.success_messages.pending'),
            })
            dispatch(closeModal())
          }
        },
      }}
      employeeId={employeeId}
    />
  )
}
